import img from './exclamation-white.svg';

export const Alert = ({show, msg}) => {
    if (show) {
        return <aside id="site-wide-alert">
            <div className="content-wrapper dark-background">
                <div className="col-3 site-alert-header">
                    <img src={img} alt="" aria-hidden="true" />
                    <h2>Alert</h2>
                </div>
                <p className="col-25 site-alert-text" dangerouslySetInnerHTML={{__html: msg}} />
            </div>
        </aside>;
    } else {
        return null;
    }
   
}